<div class="flex-center-center w100 flex-direction-column" appClickOutiside (clickOutside)="clickOutside()" #Containter
  style="max-height: 100%;overflow: scroll">
  <div class="w100 margin-10" [ngStyle]="{'order':1}">
    <ng-template [ngTemplateOutlet]="searchBar"></ng-template>
  </div>
  <div class="w100" [hidden]="!multiple||!showChipList" [ngStyle]="{'order':2}">
    <ng-template [ngTemplateOutlet]="chipsList"></ng-template>
  </div>
  <!--    <div class="w100"-->
  <!--         [hidden]="!openList"-->
  <!--         [ngStyle]="{'order':3}">-->
  <!--        <ng-template [ngTemplateOutlet]="selectionList"></ng-template>-->
  <!--        <mat-divider style="margin-bottom: 20px;margin-top: -10px"></mat-divider>-->
  <!--    </div>-->
</div>


<form [formGroup]="formGroup">
  <ng-template #searchBar>
    <button mat-raised-button class="flex-between-center w100" color="primary"
      style="height:55px;margin-bottom:23px;border: 1px solid #9e9e9e;border-radius: 4px;cursor: pointer"
      [matMenuTriggerFor]="menu" (click)="beforeOpenMenu()">
      @if (labelSearch) {
      <span>{{ labelSearch|translate }}</span>
      }
      <mat-icon matPrefix>search</mat-icon>
    </button>
  </ng-template>
  <ng-template #selectionList>
    @if (showButtonShowDisabledItem) {
    <button mat-stroked-button color="primary" class="w100" (click)="clickMostraNonAttivi()">

      <mat-icon>
        @if ((showNotActived$|async)==true) {
        {{ 'hidden_disabled'|translate }}
        expand_less
        } @else {
        {{ 'show_disabled'|translate }}
        expand_more
        }
      </mat-icon>

    </button>
    }
    @if (possibleValues!=null) {
    <mat-selection-list class="w100" formControlName="options" [multiple]="multiple">
      <div class="flex-start-center flex-direction-row w100">
        <!--                <ng-container-->
        <!--                        *ngFor="let value of possibleValues">-->
        <!--                    <div class="item"-->
        <!--                         [ngClass]="{'not-display':(value|transformValueByPredicateFunction:predicateFilterFunction:(filteredName$|async):translateService)||-->
        <!--                         ((showNotActived$|async)!=true&&(value|transformValueByPredicateFunction:predicateIsDisabled:activedPossibleValues:disabledPossibleValues))}">-->
        <!--                        <mat-list-option-->
        <!--                                color="primary"-->
        <!--                                [disabled]="value.disabled||(value|transformValueByPredicateFunction:predicateIsDisabled:activedPossibleValues:disabledPossibleValues)"-->
        <!--                                [value]="value.objectId">-->
        <!--                            <span style="word-break: break-word;">-->
        <!--                                <ng-container *ngIf="value.traduction;else noTraduction">-->
        <!--                                  {{value.traduction|translate}}-->
        <!--                                </ng-container>-->
        <!--                               <ng-template #noTraduction>-->
        <!--                                 {{value.noTraduction}}-->
        <!--                              </ng-template></span>-->
        <!--                        </mat-list-option>-->
        <!--                    </div>-->
        <!--                </ng-container>-->
      </div>
    </mat-selection-list>
    }

  </ng-template>
  <ng-template #chipsList>
    <div class="flex-start-center flex-direction-row" style="margin-top: -18px;margin-bottom: 15px">
      @for (value of (selectedChips$|async); track value) {
      <div class="chips-child box-shadow-3d background-color-primary" style="word-break: break-all">
        <div class="flex-start-center">
          <mat-icon (click)="removeToSelect(value)" class="icon-small" style="cursor: pointer">clear
          </mat-icon>
          <span style="margin-left: 5px;margin-right: 5px;">
            @if (value.traductionSensorData) {
            {{ (value.traductionSensorData|sensorDataTraduction$)|async }}
            } @else if (value.traductionCustomSensorData) {
            {{ (value.traductionCustomSensorData|customSensorDataTraduction$)|async }}
            } @else if (value.traduction) {
            {{ value.traduction|translate }}
            } @else {
            {{ value.noTraduction }}
            }
          </span>
        </div>
      </div>
      }
    </div>
  </ng-template>
</form>


<mat-menu #menu="matMenu" [hasBackdrop]="true" xPosition="before" class="custom-mat-menu" style="margin-top: 20px">
  <form [formGroup]="formGroup" (click)="$event.stopPropagation()">
    <div style="margin: 5px" class="flex-center-center" (click)="resetSlection()">
      <button mat-flat-button color="accent">
        {{ 'removeSelection'|translate }}
      </button>
    </div>
    <mat-form-field (focusin)="inSearchIn()" class="w100" appearance="outline">
      @if (labelSearch) {
      <mat-label>{{ labelSearch|translate }}</mat-label>
      }
      <input matInput formControlName="name" [autofocus]="true" (focus)="$event.stopPropagation();">
      <button (click)="$event.stopPropagation();" mat-icon-button matSuffix [disabled]="true">
        @if (!getMenuIsOpen()) {
        <mat-icon style="color: black!important;">
          search
        </mat-icon>
        } @else {
        <mat-icon class="text-color-primary">
          search
        </mat-icon>
        }
      </button>
    </mat-form-field>

    <div style="max-height: calc(100vh - 280px);width:auto;max-width:100%;max-overflow-y: scroll">
      @if (possibleValues!=null) {
      <mat-selection-list class="w100" formControlName="options" [multiple]="multiple">
        @for (value of possibleValues; track value; let last = $last) {
        <div mat-menu-item style="max-width: 100%" (click)="$event.stopPropagation()"
          [ngClass]="{'not-display':(value|transformValueByPredicateFunction:predicateFilterFunction:(filteredName$|async):getTraduction)||
                                         ((showNotActived$|async)!=true&&(value|transformValueByPredicateFunction:predicateIsDisabled:activedPossibleValues:disabledPossibleValues))}">
          <mat-list-option style="height:unset;width: auto;max-width: 100%" [value]="value.objectId" class="w100">
            <span style="word-break: break-word;max-width: 100%">
              @if (value.traductionSensorData) {
              {{ (value.traductionSensorData|sensorDataTraduction$)|async }}
              } @else if (value.traductionCustomSensorData) {
              {{ (value.traductionCustomSensorData|customSensorDataTraduction$)|async }}
              } @else if (value.traduction) {
              {{ value.traduction|translate }}
              } @else {
              {{ value.noTraduction }}
              }
            </span>
          </mat-list-option>
          @if (!last) {
          <mat-divider></mat-divider>
          }
        </div>
        }
      </mat-selection-list>
      }
      <div style="padding: 0 15px"></div>
    </div>


    <!--                    <div class="item"-->
    <!--                         [ngClass]="{'not-display':(value|transformValueByPredicateFunction:predicateFilterFunction:(filteredName$|async):translateService)||-->
    <!--                         ((showNotActived$|async)!=true&&(value|transformValueByPredicateFunction:predicateIsDisabled:activedPossibleValues:disabledPossibleValues))}">-->
    <!--                        <mat-list-option-->
    <!--                                color="primary"-->
    <!--                                [disabled]="value.disabled||(value|transformValueByPredicateFunction:predicateIsDisabled:activedPossibleValues:disabledPossibleValues)"-->
    <!--                                [value]="value.objectId">-->
    <!--                            <span style="word-break: break-word;">-->
    <!--                                <ng-container *ngIf="value.traduction;else noTraduction">-->
    <!--                                  {{value.traduction|translate}}-->
    <!--                                </ng-container>-->
    <!--                               <ng-template #noTraduction>-->
    <!--                                 {{value.noTraduction}}-->
    <!--                              </ng-template></span>-->
    <!--                        </mat-list-option>-->
    <!--                    </div>-->
  </form>

</mat-menu>